import { useState } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import RoundedButton from 'shared/buttons/RoundedButton';
import { OnOutsideClick } from "@dnhb/functional-component";
import FilterSvg from 'images/shared/filter.svg';

export const FilterButton = styled(RoundedButton)(({ active, theme }) => ({
  borderRadius: '50%',
  height: '32px',
  width: '32px',
  minWidth: 'auto',
  padding: '4px',
  backgroundColor: active && theme.primaryColor,
  svg: {
    display: 'block',
    height: '24px',
    width: '24px',
    fill: active ? theme.secondaryFontColor : theme.primaryColor,
  },
}));

const dropdownArrow = theme => ({
  border: 'solid transparent',
  borderBottomColor: theme.cardColor,
  borderWidth: '12px',
  content: '" "',
  position: 'absolute',
  left: '8px',
  bottom: '100%',
  pointerEvents: 'none',
  height: 0,
  width: 0,
  transform: 'scale(0.8) translateY(4px)',
});

const Dropdown = styled.div(({ theme }) => ({
  background: theme.cardColor,
  position: 'absolute',
  top: '48px',
  boxSizing: 'border-box',
  width: '424px',
  boxShadow: '0 2px 8px 3px rgba(0, 0, 0, 0.15)',
  fontSize: '14px',
  color: theme.primaryFontColor,
  lineHeight: '22px',
  letterSpacing: '-0.1px',
  borderRadius: '3px',
  padding: '24px',
  zIndex: 1,
  transform: 'translateX(-5px)',
  '&::before': {
    ...dropdownArrow(theme),
    borderBottomColor: 'rgba(0, 0, 0, 0.05)',
    transform: 'scale(0.8) translateY(3px)',
  },
  '&::after': dropdownArrow(theme),
  '> *:not(:last-of-type)': {
    marginBottom: '24px',
  },
}));

const FilterDropdownContainer = styled.div({
  position: 'relative',
});

const FilterDropdown = ({ children, ...props }) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <FilterDropdownContainer {...props}>
      <FilterButton onClick={() => setOpen(open => !open)} active={isOpen}>
        <FilterSvg />
      </FilterButton>
      {isOpen && (
        <OnOutsideClick onOutsideClick={() => setOpen(false)}>
          <Dropdown>{children}</Dropdown>
        </OnOutsideClick>
      )}
    </FilterDropdownContainer>
  );
};

FilterDropdown.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FilterDropdown;
